export enum AppActionType {
  SET_ENVIRONMENT = 'SET_ENVIRONMENT',
}
